import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class FeedbackService {
  private openRequested = new Subject<void>();
  openRequested$ = this.openRequested.asObservable();

  requestOpen(): void {
    this.openRequested.next();
  }
}
